import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AngularPlugin } from "@microsoft/applicationinsights-angularplugin-js";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ApplicationInsightsService {
  constructor() {}
  public initialize(router: Router) {
    if (!environment.applicationInsights.enable) return;
    try {
      var angularPlugin = new AngularPlugin();
      const appInsights = new ApplicationInsights({
        config: {
          connectionString: environment.applicationInsights.connectionString,
          // *** If you're adding the Click Analytics plug-in, delete the next line. ***
          extensions: [angularPlugin],
          // *** Add the Click Analytics plug-in. ***
          // extensions: [angularPlugin, clickPluginInstance],
          extensionConfig: {
            [angularPlugin.identifier]: { router: router },
            // *** Add the Click Analytics plug-in. ***
            // [clickPluginInstance.identifier]: clickPluginConfig
          },
        },
      });
      appInsights.loadAppInsights();
    } catch (e) {
      console.error("Error adding Microsoft Application Insights", e);
    }
  }
}
